import React from 'react';
import clsx from 'clsx';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import {
    Dialog,
    Tabs,
    Tab,
    DialogContent,
    Button,
    AppBar,
    CircularProgress,
    Grid,
    DialogActions,
    Typography
} from '@material-ui/core';

import EqualizerIcon from '@material-ui/icons/Equalizer';
import SortByAlphaIcon from '@material-ui/icons/SortByAlpha';
import InfoIcon from '@material-ui/icons/Info';

import { DialogTitle, TabControl, Overview, ListDetail } from './components';

const styles = theme => ({
    root: {
        flexGrow: 1
    },
    tabs: {
        boxShadow: 'none',
        borderTop: '1px solid #eee'
    },
    contentInfo: {
        marginTop: theme.spacing(2)
    },
    contentOverview: {
        marginTop: theme.spacing(3)
    },
    contentList: {
        marginTop: theme.spacing(2)
    }
});

class DialogDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            step: 0,
            label: 'Chargement en cours...',
            overview: [],
            market: [],
            merchant: [],
            stats: [],
            open: true,
            init: true
        };
    }

    componentDidMount = () => {
        this.getData();
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (this.state.step == 0 && this.state.step != prevState.step) {
            this.getData();
        }
    };

    getData = () => {
        const { siret } = this.props.params;

        const { start, end } = this.props.date;

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/merchant/attendance/detail/${siret.split('-')[0]}/${
                siret.split('-')[1]
            }/${start}/${end}`,
            {
                method: 'GET'
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    ...data,
                    init: false,
                    isLoading: false
                });
            })
            .catch(error => {
                this.setState({
                    init: false,
                    isLoading: false
                });
                console.error(error);
                alert('Echec de la récupération des données');
            });
    };

    handleStep = (event, value) => {
        this.setState({
            step: value
        });
    };

    handleClose = () => {
        this.props.history.goBack();
    };

    render() {
        const { classes, step, init, market, merchant, label, overview, stats } = this.state;

        return (
            <Dialog fullWidth maxWidth={'sm'} onClose={this.handleClose} open>
                <DialogTitle onClose={this.handleClose} step={step}>
                    {merchant.socialReason} - {market.label}
                </DialogTitle>
                <AppBar position="sticky" color="inherit" className={classes.tabs}>
                    <Tabs
                        value={step}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                        variant="fullWidth"
                        selectionFollowsFocus
                        onChange={this.handleStep}>
                        <Tab
                            label="Vue d'ensemble"
                            icon={<EqualizerIcon />}
                            disabled={init}
                            component={Button}
                            fullWidth
                        />
                        <Tab
                            label="Liste détaillée"
                            icon={<SortByAlphaIcon />}
                            disabled={init}
                            component={Button}
                            fullWidth
                        />
                    </Tabs>
                </AppBar>
                <DialogContent dividers>
                    <div className={classes.contentInfo}>
                        <Grid
                            container
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            justify="flex-start">
                            <Grid item>
                                <InfoIcon color="primary" />
                            </Grid>
                            <Grid item>
                                <Typography variant="body1" color="primary">
                                    {merchant.isHolder ? (
                                        <React.Fragment>
                                            Ce commerçant est titularisé sur la place{' '}
                                            <strong>N°{merchant.placeNumber}</strong> avec{' '}
                                            <strong>{merchant.meters} mètres linéaires</strong>
                                        </React.Fragment>
                                    ) : (
                                        'Ce commerçant est un passager'
                                    )}
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                    <div
                        className={clsx({
                            [classes.contentOverview]: Boolean(step == 0),
                            [classes.contentList]: Boolean(step == 1)
                        })}>
                        {!init ? (
                            <React.Fragment>
                                <TabControl value={step} index={0}>
                                    <Overview
                                        data={{
                                            merchant: merchant,
                                            overview: overview,
                                            market: market
                                        }}
                                    />
                                </TabControl>
                                <TabControl value={step} index={1}>
                                    <ListDetail
                                        date={{
                                            start: this.props.date.start,
                                            end: this.props.date.end
                                        }}
                                        siret={this.props.params.siret.split('-')[0]}
                                        isHolder={merchant.isHolder}
                                        market_id={this.props.params.siret.split('-')[1]}
                                    />
                                </TabControl>
                            </React.Fragment>
                        ) : (
                            <Grid container direction="row" alignItems="center" justify="center">
                                <Grid item>
                                    <CircularProgress />
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Fermer
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(DialogDetail);
